<template>
  <div id="numberBaseinfo">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'numberBaseinfo'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/number/Baseinfo.vue